import { hasActionAuth } from "../../authorization";

export default function ChatflowAuthMixin(pageName = "Chatflows") {
  return {
    methods: {
      hasAuth(action) {
        return hasActionAuth(pageName, action);
      },
    },
  };
}
